export default __webpack_public_path__ + "static/media/local-shops-germany-france-belgium-netherlands.23960fe1.png";